export enum Lang {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
  PT = 'pt',
  NL = 'nl',
  PL = 'pl',
}

export const LANGUAGES: { code: Lang; label: string }[] = [
  { code: Lang.EN, label: 'English' },
  { code: Lang.DE, label: 'Deutsch' },
  { code: Lang.FR, label: 'Français' },
  { code: Lang.IT, label: 'Italiano' },
  { code: Lang.ES, label: 'Español' },
  { code: Lang.PT, label: 'Português' },
  { code: Lang.NL, label: 'Nederlands' },
  { code: Lang.PL, label: 'Polski' },
];
